import { render, staticRenderFns } from "./NsAuthHeader.vue?vue&type=template&id=c8fe1ea6&scoped=true&"
import script from "./NsAuthHeader.vue?vue&type=script&lang=js&"
export * from "./NsAuthHeader.vue?vue&type=script&lang=js&"
import style0 from "./NsAuthHeader.vue?vue&type=style&index=0&id=c8fe1ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fe1ea6",
  null
  
)

export default component.exports